import React from 'react';
import ReactDOM from 'react-dom';
import './popup.css'

export default class Times extends React.Component  {
    constructor(props) {
        super(props);
        this.state = {
            vis: false,
        }

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.setState({vis: !this.state.vis});
    }

    handleClick() {
        this.setState({vis: !this.state.vis});
    }

    render() {
        return (
            <>
                <button className='fourKeys_item-link' onClick={this.handleClick}>Learn more</button>
                {this.state.vis && <div onClick={this.handleClick} className='popup' key={`popup-${this.props.key}`}>
                    <div className='popup_container'>
                        <h4 className='popup_title'>Topics</h4>
                        <ul className='popup_list'>
                            {this.props.topics.map(item => <li className='fourKeys_topic'>{item.topic}</li>)}
                        </ul>
                        <a className='popup_link' onClick={()=> window.open(this.props.href, "_self")} href={this.props.link} target='_self' rel='noreferrer'>Find Out More</a>
                    </div>
                </div>}
            </>
        )
    }
}